import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useListAssetsQuery } from '~/queries/useAssetStorageQuery';
import { ApiHelperSelectInput, ApiHelperSelectInputWrapperProps } from './ApiHelperSelectInput';

export const SelectAssetId: FC<ApiHelperSelectInputWrapperProps> = ({
  value,
  setValue,
  ...props
}) => {
  const { t } = useTranslation();

  const { data = { data: [] }, isLoading } = useListAssetsQuery();

  const items = useMemo(
    () =>
      data.data.map((item) => ({
        label: item.alias,
        value: item.assetId,
      })),
    [data],
  );

  return (
    <ApiHelperSelectInput
      label={t('assetStorage.aliasPlaceholder')}
      items={items}
      onChange={(value) => setValue('asset_id', value)}
      loading={isLoading}
      value={value}
      {...props}
    />
  );
};
